<template>
  <div>
    <div class="title">
      <!-- {{ speedTitle }} -->
      {{ $t("langcfg.txtSpeedTitle") }}
    </div>
    <div id="body">
      <div>
        <div class="smallTitle">
          <!-- {{ title }} -->
          {{ $t("langcfg.txtSpeedsmTitle") }}
        </div>
        <div v-for="it in speedData">
          <div class="bodyTitle">
            {{ $t(`langcfg.${it.title}`) }}
            <template v-for="its in it.center">
              <div class="bodyTitleSmall">
                {{ $t(`langcfg.${its.word}`) }}
              </div>
              <div class="bodyAt" v-if="it.id === 0">
                <template v-for="val in its.smallWord">
                  <div class="bodyAtCenter">
                    <div class="bodyAtCenterTit">{{ $t(`langcfg.${val.title}`) }}</div>
                    <div class="bodyAtCenterCen" id="visit">
                      <div
                        class="bodyAtCenterCenDiv"
                        :class="{ addBodyBorColor: val.typeYCheck === 1 }"
                        @click="speedCheck(it, its, val, 1)"
                      >
                        <!-- {{ val.typeY }} -->
                        {{ $t(`langcfg.${val.typeY}`) }}
                      </div>
                      <div
                        class="bodyAtCenterCenDiv"
                        @click="speedCheck(it, its, val, 0)"
                        :class="{ addBodyBorColor: val.typeNCheck === 1 }"
                      >
                        <!-- {{ val.typeN }} -->
                        {{ $t(`langcfg.${val.typeN}`) }}
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="bodyBor" id="speed1" v-else>
                <template v-for="val in its.smallWord">
                  <div
                    class="bodyBorder"
                    @click="speedCheck2(it, its, val)"
                    :class="{ addBodyBorColor: val.check === 1 }"
                  >
                    {{ $t(`langcfg.${val.title}`) }}
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!--      <div class="botWord">-->
      <!--        Cornea. 2013 Sep;32(9):1204-10-->
      <!--        <br>-->
      <!--        © 2011 TearScience, Inc. All rights reserved.-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import "./index.css";

export default {
  name: "speed",
  props: ["propsChild"],
  data() {
    return {
      speedCheckArr: [],
      // title: 'For the Standardized Patient Evaluation of Eye Dryness (SPEED) Questionnaire, please answer the following questions by checking the box that best represents your answer. Select only one answer per question.',
      speedData: [
        {
          // 'title': ' 1. Report the type of SYMPTOMS you experience and when they occur:',
          title: "txtSpeedquesiotnTitleA",
          id: 0,
          center: [
            {
              id: 0,
              // 'word': ' Dryness, Grittiness or Scratchiness',
              word: "txtDrynessGrittinessorScratchiness",
              smallWord: [
                {
                  // 'title': 'At this visit',
                  title: "txtAtthisvisit",
                  typeY: "txtYes",
                  typeYCheck: "0",
                  typeNCheck: "0",
                  typeN: "txtNo",
                  id: 0
                },
                {
                  // 'title': 'Within past 72 hours',
                  title: "txtWithinpast72hours",
                  typeY: "txtYes",
                  typeN: "txtNo",
                  typeYCheck: "0",
                  typeNCheck: "0",
                  id: 1,
                  check: "0"
                },
                {
                  // 'title': 'Within past 3 months',
                  title: "txtWithinpast3months",
                  typeY: "txtYes",
                  typeN: "txtNo",
                  typeYCheck: "0",
                  typeNCheck: "0",
                  id: 2,
                  check: "0"
                }
              ]
            },
            {
              id: 1,
              // 'word': 'Soreness or Irritation',
              word: "txtSorenessorIrritation",
              smallWord: [
                {
                  // 'title': 'At this visit',
                  title: "txtAtthisvisit",
                  typeY: "txtYes",
                  typeN: "txtNo",
                  typeYCheck: "0",
                  typeNCheck: "0",
                  id: 0,
                  check: "0"
                },
                {
                  // 'title': 'Within past 72 hours',
                  title: "txtWithinpast72hours",
                  typeY: "txtYes",
                  typeN: "txtNo",
                  id: 1,
                  typeYCheck: "0",
                  typeNCheck: "0",
                  check: "0"
                },
                {
                  // 'title': 'Within past 3 months',
                  title: "txtWithinpast3months",
                  typeY: "txtYes",
                  typeN: "txtNo",
                  id: 2,
                  typeYCheck: "0",
                  typeNCheck: "0",
                  check: "0"
                }
              ]
            },
            {
              id: 2,
              // 'word': 'Burning or Watering',
              word: "txtBurningorWatering",
              smallWord: [
                {
                  // 'title': 'At this visit',
                  title: "txtAtthisvisit",
                  typeY: "txtYes",
                  typeYCheck: "0",
                  typeNCheck: "0",
                  typeN: "txtNo",
                  id: 0,
                  check: "0"
                },
                {
                  // 'title': 'Within past 72 hours',
                  title: "txtWithinpast72hours",
                  typeY: "txtYes",
                  typeN: "txtNo",
                  typeYCheck: "0",
                  typeNCheck: "0",
                  id: 1,
                  check: "0"
                },
                {
                  // 'title': 'Within past 3 months',
                  title: "txtWithinpast3months",
                  typeY: "txtYes",
                  typeN: "txtNo",
                  id: 2,
                  typeYCheck: "0",
                  typeNCheck: "0",
                  check: "0"
                }
              ]
            },
            {
              id: 3,
              // 'word': 'Eye Fatigue',
              word: "txtEyeFatigue",
              smallWord: [
                {
                  // 'title': 'At this visit',
                  title: "txtAtthisvisit",
                  typeY: "txtYes",
                  typeN: "txtNo",
                  typeYCheck: "0",
                  typeNCheck: "0",
                  id: 0,
                  check: "0"
                },
                {
                  // 'title': 'Within past 72 hours',
                  title: "txtWithinpast72hours",
                  typeY: "txtYes",
                  typeN: "txtNo",
                  typeYCheck: "0",
                  typeNCheck: "0",
                  id: 1,
                  check: "0"
                },
                {
                  // 'title': 'Within past 3 months',
                  title: "txtWithinpast3months",
                  typeY: "txtYes",
                  typeN: "txtNo",
                  id: 2,
                  typeYCheck: "0",
                  typeNCheck: "0",
                  check: "0"
                }
              ]
            }
          ]
        },
        {
          // 'title': '2. Report the FREQUENCY of your symptoms using the rating list below:',
          title: "txtSpeedquesiotnTitleB",
          id: 1,
          center: [
            {
              id: 0,
              // 'word': ' Dryness, Grittiness or Scratchiness',
              word: "txtDrynessGrittinessorScratchiness",
              smallWord: [
                {
                  title: "txtNeverforSpeed",
                  value: "0",
                  id: 0,
                  check: "0"
                },
                {
                  title: "txtSometimes",
                  value: "1",
                  id: 1,
                  check: "0"
                },
                {
                  title: "txtOften",
                  value: "2",
                  id: 2,
                  check: "0"
                },
                {
                  title: "txtConstant",
                  value: "3",
                  id: 3,
                  check: "0"
                }
              ]
            },
            {
              id: 1,
              // 'word': 'Soreness or Irritation',
              word: "txtSorenessorIrritation",
              smallWord: [
                {
                  title: "txtNeverforSpeed",
                  value: "0",
                  id: 0,
                  check: "0"
                },
                {
                  title: "txtSometimes",
                  value: "1",
                  id: 1,
                  check: "0"
                },
                {
                  title: "txtOften",
                  value: "2",
                  id: 2,
                  check: "0"
                },
                {
                  title: "txtConstant",
                  value: "3",
                  id: 3,
                  check: "0"
                }
              ]
            },
            {
              id: 2,
              word: "txtBurningorWatering",
              smallWord: [
                {
                  title: "txtNeverforSpeed",
                  value: "0",
                  id: 0,
                  check: "0"
                },
                {
                  title: "txtSometimes",
                  value: "1",
                  id: 1,
                  check: "0"
                },
                {
                  title: "txtOften",
                  value: "2",
                  id: 2,
                  check: "0"
                },
                {
                  title: "txtConstant",
                  value: "3",
                  id: 3,
                  check: "0"
                }
              ]
            },
            {
              id: 3,
              word: "txtEyeFatigue",
              smallWord: [
                {
                  title: "txtNeverforSpeed",
                  value: "0",
                  id: 0,
                  check: "0"
                },
                {
                  title: "txtSometimes",
                  value: "1",
                  id: 1,
                  check: "0"
                },
                {
                  title: "txtOften",
                  value: "2",
                  id: 2,
                  check: "0"
                },
                {
                  title: "txtConstant",
                  value: "3",
                  id: 3,
                  check: "0"
                }
              ]
            }
          ]
        },
        {
          // 'title': '3. Report the SEVERITY of your symptoms using the rating list below:',
          title: "txtSpeedquesiotnTitleC",
          id: 2,
          center: [
            {
              id: 0,
              // 'word': ' Report the SEVERITY of your symptoms using the rating list below:',
              word: "txtDrynessGrittinessorScratchiness",
              smallWord: [
                {
                  title: "txtNoProblem",
                  value: "0",
                  id: 0,
                  check: "0"
                },
                {
                  title: "txtTolerable",
                  value: "1",
                  id: 1,
                  check: "0"
                },
                {
                  title: "txtUncomfortable",
                  value: "2",
                  id: 2,
                  check: "0"
                },
                {
                  title: "txtBothersome",
                  value: "3",
                  id: 3,
                  check: "0"
                },
                {
                  title: "txtIntolerable",
                  value: "4",
                  id: 4,
                  check: "0"
                }
              ]
            },
            {
              id: 1,
              word: "txtSorenessorIrritation",
              smallWord: [
                {
                  title: "txtNoProblem",
                  value: "0",
                  id: 0,
                  check: "0"
                },
                {
                  title: "txtTolerable",
                  value: "1",
                  id: 1,
                  check: "0"
                },
                {
                  title: "txtUncomfortable",
                  value: "2",
                  id: 2,
                  check: "0"
                },
                {
                  title: "txtBothersome",
                  value: "3",
                  id: 3,
                  check: "0"
                },
                {
                  title: "txtIntolerable",
                  value: "4",
                  id: 4,
                  check: "0"
                }
              ]
            },
            {
              id: 2,
              word: "txtBurningorWatering",
              smallWord: [
                {
                  title: "txtNoProblem",
                  value: "0",
                  id: 0,
                  check: "0"
                },
                {
                  title: "txtTolerable",
                  value: "1",
                  id: 1,
                  check: "0"
                },
                {
                  title: "txtUncomfortable",
                  value: "2",
                  id: 2,
                  check: "0"
                },
                {
                  title: "txtBothersome",
                  value: "3",
                  id: 3,
                  check: "0"
                },
                {
                  title: "txtIntolerable",
                  value: "4",
                  id: 4,
                  check: "0"
                }
              ]
            },
            {
              id: 3,
              word: "txtEyeFatigue",
              smallWord: [
                {
                  title: "txtNoProblem",
                  value: "0",
                  id: 0,
                  check: "0"
                },
                {
                  title: "txtTolerable",
                  value: "1",
                  id: 1,
                  check: "0"
                },
                {
                  title: "txtUncomfortable",
                  value: "2",
                  id: 2,
                  check: "0"
                },
                {
                  title: "txtBothersome",
                  value: "3",
                  id: 3,
                  check: "0"
                },
                {
                  title: "txtIntolerable",
                  value: "4",
                  id: 4,
                  check: "0"
                }
              ]
            }
          ]
        },
        {
          // 'title': '4. Do you use eye drops for lubrication?',
          title: "txtSpeedquesiotnTitleD",
          id: 3,
          center: [
            {
              id: 0,
              word: "txtEm",
              smallWord: [
                {
                  title: "txtYes",
                  id: 0,
                  value: 0,
                  check: "0"
                },
                {
                  title: "txtNo",
                  id: 1,
                  value: 0,
                  check: "0"
                }
              ]
            }
          ]
        }
      ],
      noCheckAll: [],
      getCount: 0
    };
  },
  methods: {
    speedCheck(it, its, val, type) {
      for (let i = 0; i < its.smallWord.length; i++) {
        its.smallWord[i].typeYCheck = "0";
        its.smallWord[i].typeNCheck = "0";
        if (type === 1) {
          this.speedData[it.id].center[its.id].smallWord[val.id].typeYCheck = 1;
        }
        if (type === 0) {
          this.speedData[it.id].center[its.id].smallWord[val.id].typeNCheck = 1;
        }
      }

      // this.speedData[it.id].center[its.id].smallWord[val.id].typeYCheck = '0'
      // this.speedData[it.id].center[its.id].smallWord[val.id].typeNCheck = '0'
      // if (type === 1) {
      //   this.speedData[it.id].center[its.id].smallWord[val.id].typeYCheck = 1
      // }
      // if (type === 0) {
      //   this.speedData[it.id].center[its.id].smallWord[val.id].typeNCheck = 1
      // }
      this.emitFun();
    },
    speedCheck2(it, its, val) {
      this.speedData[it.id].center[its.id].smallWord[val.id].check = "0";
      for (let i = 0; i < this.speedData[it.id].center[its.id].smallWord.length; i++) {
        this.speedData[it.id].center[its.id].smallWord[i].check = "0";
      }
      this.speedData[it.id].center[its.id].smallWord[val.id].check = 1;
      this.emitFun();
    },
    emitFun() {
      this.speedCheckArr = [];
      this.noCheckAll = [];
      for (let i = 0; i < this.speedData.length; i++) {
        for (let j = 0; j < this.speedData[i].center.length; j++) {
          for (let z = 0; z < this.speedData[i].center[j].smallWord.length; z++) {
            if (this.speedData[i].center[j].smallWord[z].check === 1) {
              this.speedCheckArr.push({
                type: "EN",
                Pid: this.speedData[i].id,
                Pid2: this.speedData[i].center[j].id,
                id: this.speedData[i].center[j].smallWord[z].id,
                val: this.speedData[i].center[j].smallWord[z].value
              });
            }
            if (this.speedData[i].center[j].smallWord[z].typeYCheck === 1) {
              this.speedCheckArr.push({
                type: "EN",
                Pid: this.speedData[i].id,
                Pid2: this.speedData[i].center[j].id,
                id: this.speedData[i].center[j].smallWord[z].id,
                val: "0",
                typeYCheck: this.speedData[i].center[j].smallWord[z].typeYCheck
              });
            } else if (this.speedData[i].center[j].smallWord[z].typeNCheck === 1) {
              this.speedCheckArr.push({
                type: "EN",
                Pid: this.speedData[i].id,
                Pid2: this.speedData[i].center[j].id,
                id: this.speedData[i].center[j].smallWord[z].id,
                val: " 0",
                typeNCheck: this.speedData[i].center[j].smallWord[z].typeNCheck
              });
            }
          }
        }
      }
      // 存储未选中
      // let isExist
      // let getCount = 0
      // let id
      // for (let i = 0; i < this.speedData.length; i++) {
      //   isExist = false
      //   for (let j = 0; j < this.speedData[i].center.length; j++) {
      //     isExist = false
      //     for (let z = 0; z < this.speedData[i].center[j].smallWord.length; z++) {
      //       if (this.speedData[i].center[j].smallWord[z].typeNCheck) {
      //         getCount++
      //         id = this.speedData[i].id
      //       }
      //       for (let a = 0; a < this.speedCheckArr.length; a++) {
      //         if (this.speedData[i].id === this.speedCheckArr[a].Pid && this.speedData[i].center[j].id === this.speedCheckArr[a].Pid2 && this.speedData[i].center[j].smallWord[z].id === this.speedCheckArr[a].id) {
      //           isExist = true
      //           break
      //         }
      //       }
      //     }
      //     if (!isExist) {
      //       this.noCheckAll.push(this.speedData[i])
      //     }
      //   }
      // }
      // let num = 0
      // for (let a = 0; a < this.speedCheckArr.length; a++) {
      //   if (this.speedCheckArr[a].typeNCheck || this.speedCheckArr[a].typeYCheck) {
      //     num++
      //   }
      // }
      // if (getCount !== num) {
      //   this.noCheckAll.unshift(this.speedData[id])
      // }
      // this.$emit('emitMcFun', this.speedCheckArr, this.noCheckAll)

      let isExist;
      for (let i = 0; i < this.speedData.length; i++) {
        isExist = false;
        for (let j = 0; j < this.speedData[i].center.length; j++) {
          isExist = false;
          for (let z = 0; z < this.speedData[i].center[j].smallWord.length; z++) {
            for (let a = 0; a < this.speedCheckArr.length; a++) {
              if (
                this.speedData[i].id === this.speedCheckArr[a].Pid &&
                this.speedData[i].center[j].id === this.speedCheckArr[a].Pid2 &&
                this.speedData[i].center[j].smallWord[z].id === this.speedCheckArr[a].id
              ) {
                isExist = true;
                break;
              }
            }
          }
          if (!isExist) {
            this.noCheckAll.push(this.speedData[i]);
          }
        }
      }

      this.$emit("emitMcFun", this.speedCheckArr, this.noCheckAll);
    },
    initShow() {
      // 前端传值显示
      this.getCount = 0;
      // const arr = '[{"type":"EN","Pid":0,"Pid2":0,"id":0,"val":"0","typeYCheck":1},{"type":"EN","Pid":0,"Pid2":0,"id":1,"val":"0","typeYCheck":1},{"type":"EN","Pid":0,"Pid2":0,"id":2,"val":"0","typeYCheck":1},{"type":"EN","Pid":0,"Pid2":1,"id":0,"val":" 0","typeNCheck":1},{"type":"EN","Pid":0,"Pid2":1,"id":1,"val":"0","typeYCheck":1},{"type":"EN","Pid":0,"Pid2":1,"id":2,"val":"0","typeYCheck":1},{"type":"EN","Pid":0,"Pid2":2,"id":0,"val":" 0","typeNCheck":1},{"type":"EN","Pid":0,"Pid2":2,"id":1,"val":"0","typeYCheck":1},{"type":"EN","Pid":0,"Pid2":2,"id":2,"val":"0","typeYCheck":1},{"type":"EN","Pid":0,"Pid2":3,"id":0,"val":" 0","typeNCheck":1},{"type":"EN","Pid":0,"Pid2":3,"id":1,"val":"0","typeYCheck":1},{"type":"EN","Pid":0,"Pid2":3,"id":2,"val":"0","typeYCheck":1},{"type":"EN","Pid":1,"Pid2":0,"id":1,"val":"1"},{"type":"EN","Pid":1,"Pid2":1,"id":1,"val":"1"},{"type":"EN","Pid":1,"Pid2":2,"id":1,"val":"1"},{"type":"EN","Pid":1,"Pid2":3,"id":1,"val":"1"},{"type":"EN","Pid":2,"Pid2":0,"id":1,"val":"1"},{"type":"EN","Pid":2,"Pid2":1,"id":1,"val":"1"},{"type":"EN","Pid":2,"Pid2":2,"id":1,"val":"1"},{"type":"EN","Pid":2,"Pid2":3,"id":1,"val":"1"},{"type":"EN","Pid":3,"Pid2":0,"id":1,"val":0}]'
      // this.propsChild = JSON.parse(arr)
      if (this.propsChild) {
        let arrAy = this.propsChild;
        for (let j = 0; j < arrAy.length; j++) {
          this.getCount++;
          for (let i = 0; i < this.speedData.length; i++) {
            if (this.speedData[i].id === arrAy[j].Pid) {
              if (this.speedData[i].id === 0) {
                this.speedData[i].center[arrAy[j].Pid2].smallWord[arrAy[j].id].typeYCheck =
                  arrAy[j].typeYCheck;
                this.speedData[i].center[arrAy[j].Pid2].smallWord[arrAy[j].id].typeNCheck =
                  arrAy[j].typeNCheck;
              } else {
                this.speedData[i].center[arrAy[j].Pid2].smallWord[arrAy[j].id].check = 1;
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    // 初始显示
    this.initShow();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/dryeye/components/questions/EN/Speed.vue